<template>
  <div class="main-page">
    <div class="header block">
      <div class="header-items">
        <!-- <img
          id="music-link"
          class="header-item"
          src="../assets/graphics/NDZ_Header_Music.svg"
          @click="scrollTo('.music')"
        /> -->
        <h1 id="music-link" class="header-item" @click="scrollTo('.music')">
          MUSIC
        </h1>
        <!-- <img
          id="shows-link"
          class="header-item"
          src="../assets/graphics/NDZ_Header_Shows.svg"
          @click="scrollTo('.shows')"
        /> -->
        <h1 id="shows-link" class="header-item" @click="scrollTo('.shows')">
          SHOWS
        </h1>
        <div class="header-item no-nav" id="header-logo-block">
          <img id="ndz-header-bird" src="../assets/graphics/NDZ_Header_Bird.svg" />
          <img id="ndz-header-thorn-wheel" src="../assets/graphics/NDZ_Header_Thorn_Wheel.svg" />
        </div>
        <!-- <img
          id="shop-link"
          class="header-item"
          src="../assets/graphics/NDZ_Header_Shop.svg"
          @click="scrollTo('.merch')"
        /> -->
        <h1 id="shop-link" class="header-item" @click="scrollTo('.merch')">
          MERCH
        </h1>
        <!-- <img
          id="contact-link"
          class="header-item"
          src="../assets/graphics/NDZ_Header_Contact.svg"
          @click="scrollTo('.footer')"
        /> -->
        <h1 id="contact-link" class="header-item" @click="scrollTo('.footer')">
          CONTACT
        </h1>
      </div>
      <div class="block">
        <img id="ndz-header-thorns" src="../assets/graphics/NDZ_Header_Thorns.svg" />
      </div>
      <img class="texture-bottom" src="../assets/graphics/Texture_Yellow-Top.svg" />
    </div>
    <!-- <div class="kit block">
      <div class="block kit-items">
        <img id="ndz-kit-img" class="kit-item" src="../assets/graphics/merch/NDZ_Cube.png" />
        <div v-if="!sent" class="kit-item">
          <h2 id="kit-header">TO RECEIVE KIT PLEASE FILL OUT AND SUBMIT:</h2>

          <label for="name">FULL NAME</label>
          <input type="text" id="name" name="name" v-model="name" @change="inputChanged('name')" />

          <label for="address">MAILING ADDRESS (Include City, State & Zip)</label>
          <input type="text" id="address" name="address" v-model="address" @change="inputChanged('address')" />

          <label for="email">EMAIL</label>
          <input type="text" id="email" name="email" v-model="email" @change="inputChanged('email')" />
          <div id="submit-panel">
            <p id="while-supplies"><b>*WHILE SUPPLIES LAST</b></p>
            <button id="kit-submit" :disabled="!validAddress || !validName || !validEmail" @click="submit()">
              SUBMIT
            </button>
          </div>
          <p id="error">
            <b>{{ error }}</b>
          </p>
        </div>
        <div v-if="sent" class="kit-item">
          <h2 id="kit-header">THANK YOU, WE HAVE RECEIVED YOUR REQUEST.</h2>
        </div>
      </div>
      <img class="texture-top" src="../assets/graphics/Texture_Yellow-Bottom.svg" />
    </div> -->
    <div class="video block">
      <div class="video-items">
        <div class="video-item">
          <h2>BATTERY / WASTE VIDEO OUT NOW</h2>
          <iframe width="50%" height="300px" src="https://www.youtube.com/embed/IGfoCPg0jAA?si=FSZk5lfLaLc8TFKm"
            title="YouTube video player" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen></iframe>
        </div>
      </div>
      <img class="texture-top" src="../assets/graphics/Texture_Yellow-Bottom.svg" />
    </div>
    <div class="music block">
      <div class="music-items">
        <div class="music-item">
          <!-- <h2>NEW SINGLE "WASTE" OUT NOW</h2>
          <iframe id="spotify" style="border-radius: 12px"
            src="https://open.spotify.com/embed/album/6ftThh8Wdf4keZBfWh9FS8?utm_source=generator" width="100%"
            height="152" frameBorder="0" allowfullscreen=""
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
          <img src="../assets/graphics/NDZ_Lyrics.svg" />
        </div>
        <div class="music-item">
          <h2>EP COMING OUT IN JANUARY</h2>
          <img src="../assets/graphics/NDZ_Battery.png" />
        </div> -->
        <h2>BATTERY EP OUT NOW</h2>
        <iframe id="spotify" style="border-radius:12px" src="https://open.spotify.com/embed/album/60qvcz15u7N34yDKf7Icdf?utm_source=generator" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
          <!-- <img src="../assets/graphics/NDZ_Lyrics.svg" /> -->
        </div>
        <div class="music-item">
          <h2></h2>
          <img src="../assets/graphics/NDZ_Battery.png" />
        </div>
      </div>
      <img class="texture-top" src="../assets/graphics/Texture_Yellow-Bottom.svg" />
      <img class="texture-bottom" src="../assets/graphics/Texture_Black.svg" />
    </div>
    <div class="shows block">
      <h1 class="yellow">SHOWS</h1>
      <div class="shows-items">
        <div class="yellow show-item" v-for="show in shows" :key="show.id" :style="datePast(show.date)">
          <p>
            <b>{{ show.date }}</b>
          </p>
          <p class="slight-right">{{ show.time }}</p>
          <p>{{ show.venue }}</p>
          <p>{{ show.location }}</p>
          <p class="tickets" @click="openTicketLink(show.tickets)" v-if="show.tickets != '' && !datePast(show.date)"><b>TICKETS</b></p>
          <p class="tickets-no-hover" v-if="show.tickets === '' || datePast(show.date)">--</p>
        </div>
        <div class="yellow center-text" v-if="shows.length === 0">
          <p></p>
          <p></p>
          <p>COMING SOON</p>
          <p>
          </p>
          <p></p>
        </div>
      </div>
      <img class="texture-bottom" src="../assets/graphics/Texture_Yellow-Top.svg" />
    </div>
    <div class="merch block">
      <h1>MERCH</h1>
      <div class="merch-items">
        <div :class="item.canPurchase
          ? 'merch-item'
          : 'merch-item noclick'
          " v-for="item in merch" :key="item.id" @click="openMerchItem(item)">
          <img :src="item.imageLink" />
          <a class="item-link" :href="item.link" v-if="item.canPurchase" target="_blank"><b>{{ item.name }}</b></a>
          <img v-if="!item.canPurchase" class="ndz-sticker" src="../assets/graphics/NDZ_Sticker.png">
        </div>
      </div>
    </div>
    <div class="footer block">
      <img class="texture-top" src="../assets/graphics/Texture_Yellow-Bottom.svg" />
      <h1>CONTACT</h1>
      <div id="contact-info">
        <h3>BAND:</h3>
        <a class="footer-link" href="mailto:nadezhdacult@gmail.com">nadezhdacult@gmail.com</a>
      </div>
      <div id="footer-bottom">
        <div id="social">
          <a href="https://www.instagram.com/nadezhdacult/" target="_blank"><img
              src="../assets/graphics/NDZ_Insta.svg" /></a>
          <a href="https://open.spotify.com/artist/4wsQ66WdYcXeK4AGmkwKiE" target="_blank"><img
              src="../assets/graphics/NDZ_Spotify.svg" /></a>
          <a href="https://music.apple.com/us/artist/nadezhda/1707765695" target="_blank"><img
              src="../assets/graphics/NDZ_Apple.svg" /></a>
        </div>
        <img id="goat" src="../assets/graphics/NDZ_Goat.svg" />
        <img id="footer-logo" src="../assets/graphics/NDZ_Footer_Logo.svg" />
      </div>
    </div>
  </div>
</template>

<script>
import emailjs from "emailjs-com";

export default {
  name: "MainPage",
  mounted() { },
  computed: {
    validEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const isValidEmail = emailRegex.test(this.email);
      return isValidEmail;
    },
    validName() {
      const nameRegex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;
      const isValidName = nameRegex.test(this.name) && this.name.length > 2;
      return isValidName;
    },
    validAddress() {
      const addressRegex = /^[a-zA-Z0-9\s,'-]*$/;
      const isValidAddress =
        addressRegex.test(this.address) && this.address.length > 6;
      return isValidAddress;
    },
    error() {
      if (!this.validEmail && this.emailDirty && this.email !== "") {
        return "Please enter a valid email address".toUpperCase();
      }
      if (!this.validName && this.nameDirty && this.name !== "") {
        return "Please enter a valid name".toUpperCase();
      }
      if (!this.validAddress && this.addressDirty && this.address !== "") {
        return "Please enter a valid address".toUpperCase();
      }
      return "";
    },
  },
  props: {
    shows: {
      type: Array,
      required: true,
    },
  },
  methods: {
    openTicketLink(url) {
      window.open(url, "_blank");
    },
    datePast(date) {
      const today = new Date();
      const showDate = this.closestDate(date);
      if (showDate < today) {
        return "";
      }
      return "text-decoration: line-through 3px;";
    },
    closestDate(dateString) {
    // Remove any ordinal suffixes
    dateString = dateString.toLowerCase();
    dateString = dateString.replace(/(\d+)(st|nd|rd|th)/, "$1");
    if(dateString.includes("-"))
      dateString = dateString.split(" -")[0];
    // Get the current date
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    // Parse the date string
    var date = new Date(dateString + " 2022");
    // If no valid date could be extracted, return null
    if (isNaN(date)) return null;
    
    // Set the year of the parsed date
    if (date.getMonth() < month) {
        date.setFullYear(year + 1);
    } else if (date.getMonth() === month && date.getDate() < now.getDate()) {
        date.setFullYear(year);
    } else {
        date.setFullYear(year - 1);
    }
    console.log(date);
    return date;
},
    submit() {
      try {
        emailjs.send(
          "service_p8uh0l8",
          "template_qjvcvxg",
          {
            name: this.name,
            email: this.email,
            message: this.name + "\n" + this.email + "\n\n" + this.address,
          },
          "oEp3EsbHOxJU0T_V-"
        );
        this.sent = true;
      } catch (error) {
        console.log({ error });
        return;
      }
      // Reset form field
      this.name = "";
      this.email = "";
      this.address = "";
      this.nameDirty = false;
      this.emailDirty = false;
      this.addressDirty = false;
    },
    scrollTo(element) {
      document.querySelector(element).scrollIntoView({
        behavior: "smooth",
      });
    },
    openMerchItem(item) {
      if (!item.canPurchase) {
        return;
      }
      window.open(item.link, "_blank");
    },
    inputChanged(input) {
      if (input === "name") {
        this.nameDirty = true;
      }
      if (input === "email") {
        this.emailDirty = true;
      }
      if (input === "address") {
        this.addressDirty = true;
      }
    },
  },
  data() {
    return {
      address: "",
      name: "",
      email: "",
      addressDirty: false,
      nameDirty: false,
      emailDirty: false,
      sent: false,
      merch: [
        {
          id: 1,
          name: "LOGO T-SHIRT",
          link: "https://nadezhda.bandcamp.com/merch/logo-t-shirt",
          imageLink: "../assets/graphics/merch/NDZ_T.png",
          canPurchase: true
        },
        {
          id: 2,
          name: "ONE OF US T-SHIRT",
          link: "https://nadezhda.bandcamp.com/merch/nadezhda-one-of-us-t-shirt",
          imageLink: "../assets/graphics/merch/NDZ_OneOfUs.png",
          canPurchase: true
        },
        {
          id: 3,
          name: "ORANGE TOTE",
          link: "https://nadezhda.bandcamp.com/merch/nadezhda-orange-tote",
          imageLink: "../assets/graphics/merch/NDZ_Tote.png",
          canPurchase: true
        },
        {
          id: 4,
          name: "IRON ON PATCH",
          link: "https://nadezhda.bandcamp.com/merch/nadezhda-goodside-patch",
          imageLink: "../assets/graphics/merch/NDZ_Patch.png",
          canPurchase: true
        },
        {
          id: 5,
          name: "NADDY BIC LIGHTER",
          link: "",
          imageLink: "../assets/graphics/merch/NDZ_Bic.png",
          canPurchase: false
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-page {
  height: 100%;
  width: 100%;
}

h1 {
  font-family: BNAxelGroteskBold;
  text-align: center;
  font-size: calc(1rem + 2vw);
  margin-bottom: 5%;
  margin-top: 0px;
  padding-top: 3%;
}

h2 {
  font-family: BNAxelGroteskBold;
  text-align: left;
  font-size: calc(0.5rem + 2vw);
}

h3 {
  font-family: BNAxelGroteskBold;
  text-align: left;
  font-size: calc(0.3rem + 2vw);
}

p {
  font-family: NeueMontrealRegular;
  font-size: calc(0.4rem + 1vw);
  margin-bottom: 1%;
}

b {
  font-family: NeueMontrealBold;
  font-size: calc(0.4rem + 1vw);
  margin-bottom: 1%;
}

a {
  font-family: NeueMontrealBold;
  font-size: calc(0.4rem + 1vw);
  margin-bottom: 1%;
}

label {
  font-family: BNAxelGroteskBold;
  text-align: left;
  font-size: calc(0.1rem + 1.5vw);
  letter-spacing: 2px;
}

input {
  font-family: BNAxelGroteskBold;
  text-align: left;
  font-size: calc(0.3rem + 2vw);
  letter-spacing: 2px;
  margin-bottom: 5%;
  margin-top: 1%;
  padding: 1%;
  background: rgba(0, 0, 0, 0);
  border: 2px solid black;
  outline: none;
}

input:active,
input:focus {
  border: 2px solid #f06825;
}

button {
  font-family: BNAxelGroteskBold;
  text-align: center;
  font-size: calc(0.3rem + 2vw);
  letter-spacing: 2px;
  margin-bottom: 5%;
  margin-top: 3%;
  padding: 1%;
  padding-left: 2%;
  padding-right: 2%;
  width: fit-content;
  background: #f06825;
  border: 2px solid #f06825;
  color: #fcb416;
  outline: none;
  margin-left: auto;
}

button:hover:not(:disabled) {
  cursor: pointer;
  background: #fcb416;
  color: #f06825;
  animation: 1s shake infinite;
}

button:disabled:hover {
  cursor: not-allowed;
}

button:disabled {
  background: #fcb416;
  color: #f0692560;
  border: 2px solid #fcb416;
}

.block {
  width: 100%;
  min-height: 100px;
  position: relative;
}

.header {
  background: #f06825;
}

.kit {
  background: #fcb416;
}

.video {
  background: #fcb416;
}

.video-items {
  display: grid;
  grid-template-rows: 1fr;
}

.video-item {
  width: 100%;
  margin-bottom: 5%;
  align-content: center;
  text-align: center;
}

.video-item h2 {
  text-align: center;
}

.video-item iframe {
  border-radius: 12px;
}

.music {
  background: #f06825;
}

.shows {
  background: black;
}

.merch {
  background: #fcb416;
}

.footer {
  background: #f06825;
  padding-top: 5%;
}

.yellow {
  color: #fcb416;
}

@media screen and (max-width: 800px) {
  #while-supplies {
    margin-left: -5%;
  }

  .header-items {
    margin-bottom: 3%;
    margin-top: 3%;
  }

  .header-item:not(#header-logo-block) {
    display: none;
  }

  .kit-items {
    display: grid;
    grid-template-rows: 1fr 1fr;
  }

  .kit-item {
    width: 80%;
    margin: 0 auto;
  }

  .music-items {
    display: grid;
    grid-template-rows: 1fr 1fr;
  }

  .texture-bottom {
    bottom: 0;
  }

  .texture-top {
    top: 0;
  }

  #header-logo-block {
    width: 130px;
    margin: 0 auto;
    height: 130px;
  }

  #ndz-header-thorns {
    width: 150%;
    margin-left: -25%;
  }

  #spotify {
    width: 80%;
  }

  .music-item img {
    width: 80%;
  }

  .merch-item {
    border-radius: 5px;
    margin: 0 auto;
    margin-top: 5%;
    text-align: center;
    display: flex;
    flex-direction: column;
    width: 60%;
  }

  h2 {
    font-size: calc(1rem + 2vw);
  }

  #error {
    top: 83%;
  }
}

@media screen and (min-width: 800px) {

  #while-supplies {
    margin-left: -10%;
  }

  .header-items {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    margin-bottom: 3%;
    margin-top: 3%;
  }

  .kit-items {
    display: grid;
    grid-template-columns: 2fr 1fr;
  }

  .kit-item {
    width: 80%;
  }

  .music-items {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .texture-bottom {
    bottom: -1%;
  }

  .texture-top {
    top: -1%;
  }

  #ndz-header-thorns {
    width: 100%;
  }

  #spotify {
    width: 80%;
  }

  .music-item img {
    width: 80%;
  }

  .merch-items {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 80%;
    margin: 0 auto;
  }

  .merch-item {
    border-radius: 5px;
    margin: 0 auto;
    margin-bottom: 5%;
    margin-top: 5%;
    text-align: center;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  #error {
    top: 82%;
  }
}

.merch-item {
  position: relative;
}

.merch-item p,
.merch-item a {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
}

.merch-item img {
  width: 100%;
}

.merch-item:hover:not(.noclick) {
  cursor: pointer;
}

.noclick {
  cursor: not-allowed;
}

.merch-item:hover a {
  color: #f06825;
}

.shows-items {
  display: flex;
  flex-direction: column;
  width: 90%;
  margin: 0 auto;
  padding-bottom: 10%;
}

.show-item {
  text-align: left;
  display: grid;
  grid-template-columns: 1fr 1fr 2fr 2fr 1fr;
  margin-left: 10%;
}

.header-item {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  position: relative;
  width: 100%;
  margin-bottom: 40%;
  font-size: calc(0.5rem + 2vw);
}

.header-item:not(.no-nav) {
  margin-top: 40%;
}

.music-item {
  justify-content: center;
  text-align: center;
  position: relative;
  margin-top: 5%;
}

.music-item h2 {
  text-align: center;
}

.music-item img {
  margin: 0 auto;
  margin-bottom: 10%;
  margin-top: 5%;
}

#spotify {
  margin: 0 auto;
  margin-top: 5%;
}

.header-item:hover:not(.no-nav) {
  cursor: pointer;
  color: #fcb416;
}

.header-item:hover:not(#header-logo-block) {
  animation: 1s shake infinite;
}

.kit-item {
  padding: 5%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  position: relative;
}

.texture-bottom {
  width: 105%;
  position: absolute;
  left: -2.5%;
  z-index: 99;
}

.texture-top {
  width: 105%;
  position: absolute;
  left: -2.5%;
  z-index: 99;
}

.shake {
  animation: 1s shake infinite;
}

#ndz-header-thorns {
  margin-bottom: 10%;
}

#ndz-header-bird {
  position: absolute;
  top: 0;
  left: 0;
}

#ndz-header-thorn-wheel {
  position: absolute;
  top: 0;
  left: 0;
  animation: rotate 12s forwards linear infinite;
}

#contact-info {
  display: flex;
  flex-direction: column;
  width: 90%;
  margin: 0 auto;
  line-height: 0px;
  margin-bottom: 5%;
}

#contact-info h3 {
  margin: 0px;
  margin-bottom: 1%;
}

#social {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 20%;
  padding-right: 10%;
}

#social img {
  max-width: 75%;
  margin-top: 100%;
}

#social img:hover {
  filter: invert(87%) sepia(27%) saturate(5982%) hue-rotate(347deg) brightness(103%) contrast(98%);
  animation: 1s shake infinite;
}

#social a {
  width: 100%;
}

#footer-bottom {
  display: flex;
  flex-direction: row;
  width: 90%;
  margin: 0 auto;
  justify-content: space-between;
  margin-bottom: 5%;
}

#goat {
  max-width: 10%;
}

#footer-logo {
  max-width: 30%;
  margin-top: 5%;
}

.tickets:hover {
  cursor: pointer;
  color: #f06825;
}

.tickets-no-hover {
  color: #fcb416;
}

.footer-link {
  margin-top: 2%;
  color: black;
  text-decoration: none;
}

.footer-link:hover {
  color: #fcb416;
}

.item-link {
  margin-top: 2%;
  color: black;
  text-decoration: none;
}

.item-link:hover {
  color: #f06825;
}

#error {
  color: red;
  font-size: calc(0.3rem + 1vw);
  scale: 0.7;
}

.merch-items {
  padding-bottom: 5%;
}

#while-supplies {
  scale: 0.7;
  color: #f06825;
}

#submit-panel {
  display: flex;
  flex-direction: row;
}

.ndz-sticker {
  position: absolute;
  top: 15%;
  right: 15%;
  transform: rotate(320deg);
  max-width: 30%;
}

.center-text {
  text-align: center;
}

.slight-right {
  margin-left: 20%;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes shake {
  0% {
    transform: translate(0px, 0px) rotate(0deg);
  }

  10% {
    transform: translate(-1px, 0px) rotate(-1deg);
  }

  20% {
    transform: translate(1px, 0px) rotate(1deg);
  }

  30% {
    transform: translate(-1px, 0px) rotate(-1deg);
  }

  40% {
    transform: translate(1px, 0px) rotate(1deg);
  }

  50% {
    transform: translate(-1px, 0px) rotate(-1deg);
  }

  60% {
    transform: translate(1px, 0px) rotate(1deg);
  }

  70% {
    transform: translate(-1px, 0px) rotate(-1deg);
  }

  80% {
    transform: translate(1px, 0px) rotate(1deg);
  }

  90% {
    transform: translate(-1px, 0px) rotate(-1deg);
  }

  100% {
    transform: translate(0px, 0px) rotate(0deg);
  }
}</style>
